// import React, { useState, useEffect } from "react";

// import { useNavigate, useLocation } from "react-router-dom";

// import ExamHeader from "../../ExamPage/ExamHeader";

// import ExamQuestionCard from "../../ExamPage/ExamQuestionCard";

// import QuestionNavigator from "../../ExamPage/QuestionNavigator";

// import ProgressOverview from "../../ExamPage/ProgressOverview";

// import SubmitExamDialog from "../../ExamPage/SubmitExamDialog";

// import ExamResults from "../../ExamPage/ExamResults";

// import "../../ExamPage/Exam.css";

// import GuidedTour from "../GuidedTour";  // ← Adjust path to match your folder structure (same as in DummyExamInstructions)
// import { fullTourSteps } from "../tourSteps";  // ← Adjust path

// export default function ExamPortalMock() {
//     const [currentQ, setCurrentQ] = useState(0);
//     const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes
//     const [usedTime, setUsedTime] = useState(0);
//     const [submitted, setSubmitted] = useState(false);
//     const [showSubmitModal, setShowSubmitModal] = useState({ open: false, isAuto: false });

//     // Simple violation simulation (for testing)
//     const [violationCount, setViolationCount] = useState(0);
//     const maxViolations = 3;

//     // Tour handling (copied from DummyExamInstructions)
//     const location = useLocation();
//     const navigate = useNavigate();  // Add this if not already there

//     const [tourStepIndex, setTourStepIndex] = useState(() => {
//         if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {
//             return location.state.stepIndex;
//         }
//         return null;
//     });

//     useEffect(() => {
//         if (location.state?.resumeTour) {
//             navigate(".", { replace: true, state: {} }); // Clear state after resuming
//         }
//     }, [location.state, navigate]);

//     // Mock exam data
//     const exam = {
//         Title: "Mock Online Test - Python Basics",
//         "Duration(min)": 30,
//         PassPercent: 60,
//         ReviewWithAnswers: true,
//     };

//     // Hardcoded questions (you can add more)
//     const questions = [
//         {
//             q: "What is the correct way to create a function in Python?",
//             options: [
//                 { key: "A", text: "function myFunc():" },
//                 { key: "B", text: "def myFunc():" },
//                 { key: "C", text: "create myFunc():" },
//                 { key: "D", text: "func myFunc():" },
//             ],
//             questionId: "q1",
//             question_type_id: 1,
//             marks: 1,
//             is_mandatory: true,
//         },
//         {
//             q: "Which of these are mutable in Python? (select all)",
//             options: [
//                 { key: "A", text: "list" },
//                 { key: "B", text: "tuple" },
//                 { key: "C", text: "set" },
//                 { key: "D", text: "string" },
//             ],
//             questionId: "q2",
//             question_type_id: 2,
//             marks: 2,
//             is_mandatory: true,
//         },
//         {
//             q: "What does PEP stand for?",
//             options: [],
//             questionId: "q3",
//             question_type_id: 3, // text
//             marks: 1,
//             is_mandatory: false,
//         },
//     ];

//     const [answers, setAnswers] = useState(Array(questions.length).fill(null));
//     const [status, setStatus] = useState(Array(questions.length).fill("not-visited"));

//     // Simple timer
//     useEffect(() => {
//         if (submitted || timeLeft <= 0) return;

//         const timer = setInterval(() => {
//             setTimeLeft((prev) => {
//                 if (prev <= 1) {
//                     setShowSubmitModal({ open: true, isAuto: true });
//                     return 0;
//                 }
//                 return prev - 1;
//             });
//             setUsedTime((prev) => prev + 1);
//         }, 1000);

//         return () => clearInterval(timer);
//     }, [submitted]);

//     // Simple violation simulation
//     const simulateViolation = () => {
//         if (violationCount >= maxViolations) return;
//         setViolationCount((prev) => {
//             const newCount = prev + 1;
//             if (newCount >= maxViolations) {
//                 setTimeout(() => setShowSubmitModal({ open: true, isAuto: true }), 1500);
//             }
//             return newCount;
//         });
//     };

//     const optionKeys = ["A", "B", "C", "D"];

//     const selectOption = (qIndex, optIndex) => {
//         const question = questions[qIndex];
//         const newAnswers = [...answers];

//         if (question.question_type_id === 1) {
//             newAnswers[qIndex] = newAnswers[qIndex] === optIndex ? null : optIndex;
//         } else if (question.question_type_id === 2) {
//             const prev = Array.isArray(newAnswers[qIndex]) ? newAnswers[qIndex] : [];
//             newAnswers[qIndex] = prev.includes(optIndex)
//                 ? prev.filter((i) => i !== optIndex)
//                 : [...prev, optIndex];
//         } else {
//             newAnswers[qIndex] = optIndex; // text input
//         }

//         setAnswers(newAnswers);

//         const isEmpty =
//             question.question_type_id === 1 ? newAnswers[qIndex] == null :
//                 question.question_type_id === 2 ? (!Array.isArray(newAnswers[qIndex]) || newAnswers[qIndex].length === 0) :
//                     !newAnswers[qIndex]?.trim();

//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = isEmpty ? "not-answered" : "answered";
//             return ns;
//         });
//     };

//     const clearResponse = (qIndex) => {
//         const newAnswers = [...answers];
//         newAnswers[qIndex] = null;
//         setAnswers(newAnswers);

//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = "not-answered";
//             return ns;
//         });
//     };

//     const markReview = (qIndex) => {
//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = "marked";
//             return ns;
//         });
//     };

//     const nextQ = () => {
//         if (currentQ < questions.length - 1) setCurrentQ(currentQ + 1);
//     };

//     const prevQ = () => {
//         if (currentQ > 0) setCurrentQ(currentQ - 1);
//     };

//     const loadQuestion = (index) => setCurrentQ(index);

//     const handleSubmit = () => {
//         setShowSubmitModal({ open: true, isAuto: false });
//     };

//     const handleFinalSubmit = () => {
//         setSubmitted(true);
//         setShowSubmitModal({ open: false, isAuto: false });
//     };

//     const answeredCount = status.filter(s => s === "answered").length;
//     const markedCount = status.filter(s => s === "marked").length;
//     const notAnsweredCount = status.filter(s => s === "not-answered").length;
//     const unansweredMandatory = questions.filter((q, i) => q.is_mandatory && status[i] !== "answered").length;

//     if (submitted) {
//         return (
//             <ExamResults
//                 questions={questions}
//                 answers={answers}
//                 status={status}
//                 usedTime={usedTime}
//                 exam={exam}
//             />
//         );
//     }

//     if (!questions.length) {
//         return <div className="text-center mt-5">Loading mock exam...</div>;
//     }

//     const currentQuestion = questions[currentQ];

//     return (
//         <>
//             {tourStepIndex !== null && tourStepIndex >= 0 && (
//                 <GuidedTour
//                     steps={fullTourSteps}
//                     stepIndex={tourStepIndex}
//                     setStepIndex={setTourStepIndex}
//                     onFinish={() => setTourStepIndex(null)}
//                 />
//             )}
//             <div className="exam-portal">
//                 {/* Quick violation test button */}
//                 <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
//                     <button
//                         onClick={simulateViolation}
//                         style={{ background: "#e74c3c", color: "white", padding: "6px 12px", border: "none", borderRadius: 4 }}
//                     >
//                         Violation ({violationCount}/{maxViolations})
//                     </button>
//                 </div>

//                 <ExamHeader title={exam.Title} timeLeft={timeLeft} />

//                 <div className="container">
//                     <div>
//                         <ExamQuestionCard
//                             question={currentQuestion}
//                             questionIndex={currentQ}
//                             selectedAnswer={answers[currentQ]}
//                             totalQuestions={questions.length}
//                             onAnswerSelect={selectOption}
//                             onPrevious={prevQ}
//                             onNext={nextQ}
//                             onMarkReview={markReview}
//                             onClearResponse={clearResponse}
//                         />
//                     </div>

//                     <div className="QuestionSubmit">
//                         <QuestionNavigator
//                             questions={questions}
//                             status={status}
//                             currentQuestion={currentQ}
//                             onQuestionSelect={loadQuestion}
//                             onSubmit={handleSubmit}
//                         />
//                         <ProgressOverview status={status} />
//                     </div>
//                 </div>

//                 <SubmitExamDialog
//                     open={showSubmitModal.open}
//                     isAuto={showSubmitModal.isAuto}
//                     onClose={() => setShowSubmitModal({ open: false, isAuto: false })}
//                     onSubmit={handleFinalSubmit}
//                     answeredCount={answeredCount}
//                     notAnsweredCount={notAnsweredCount}
//                     markedCount={markedCount}
//                     examId="mock-001"
//                     examEmployeeId="EMP-TEST-123"
//                     unansweredMandatoryCount={unansweredMandatory}
//                 />
//             </div>
//         </>

//     );
// }

// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import ExamHeader from "../../ExamPage/ExamHeader";
// import ExamQuestionCard from "../../ExamPage/ExamQuestionCard";
// import QuestionNavigator from "../../ExamPage/QuestionNavigator";
// import ProgressOverview from "../../ExamPage/ProgressOverview";
// import SubmitExamDialogDemo from "./SubmitExamDialogDemo";
// import ExamResults from "../../ExamPage/ExamResults";
// import "../../ExamPage/Exam.css";
// import GuidedTour from "../GuidedTour";
// import { fullTourSteps } from "../tourSteps";

// export default function ExamPortalMock() {
//     const [currentQ, setCurrentQ] = useState(0);
//     const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes
//     const [usedTime, setUsedTime] = useState(0);
//     const [submitted, setSubmitted] = useState(false);
//     const [showSubmitModal, setShowSubmitModal] = useState({ open: false, isAuto: false });

//     // Simple violation simulation (for testing)
//     const [violationCount, setViolationCount] = useState(0);
//     const maxViolations = 3;

//     // Tour handling
//     const location = useLocation();
//     const navigate = useNavigate();

//     const [tourStepIndex, setTourStepIndex] = useState(() => {
//         if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {
//             return location.state.stepIndex;
//         }
//         return null;
//     });

//     useEffect(() => {
//         if (location.state?.resumeTour) {
//             navigate(".", { replace: true, state: {} });
//         }
//     }, [location.state, navigate]);

//     // Mock exam data
//     const exam = {
//         Title: "Mock Online Test - Python Basics",
//         "Duration(min)": 30,
//         PassPercent: 60,
//         ReviewWithAnswers: true,
//     };

//     // Hardcoded questions
//     const questions = [
//         {
//             q: "What is the correct way to create a function in Python?",
//             options: [
//                 { key: "A", text: "function myFunc():" },
//                 { key: "B", text: "def myFunc():" },
//                 { key: "C", text: "create myFunc():" },
//                 { key: "D", text: "func myFunc():" },
//             ],
//             questionId: "q1",
//             question_type_id: 1,
//             marks: 1,
//             is_mandatory: true,
//         },
//         {
//             q: "Which of these are mutable in Python? (select all)",
//             options: [
//                 { key: "A", text: "list" },
//                 { key: "B", text: "tuple" },
//                 { key: "C", text: "set" },
//                 { key: "D", text: "string" },
//             ],
//             questionId: "q2",
//             question_type_id: 2,
//             marks: 2,
//             is_mandatory: true,
//         },
//         {
//             q: "What does PEP stand for?",
//             options: [],
//             questionId: "q3",
//             question_type_id: 3,
//             marks: 1,
//             is_mandatory: false,
//         },
//     ];

//     const [answers, setAnswers] = useState(Array(questions.length).fill(null));
//     const [status, setStatus] = useState(Array(questions.length).fill("not-visited"));

//     // Timer
//     useEffect(() => {
//         if (submitted || timeLeft <= 0) return;

//         const timer = setInterval(() => {
//             setTimeLeft((prev) => {
//                 if (prev <= 1) {
//                     setShowSubmitModal({ open: true, isAuto: true });
//                     return 0;
//                 }
//                 return prev - 1;
//             });
//             setUsedTime((prev) => prev + 1);
//         }, 1000);

//         return () => clearInterval(timer);
//     }, [submitted]);

//     // Violation simulation
//     const simulateViolation = () => {
//         if (violationCount >= maxViolations) return;
//         setViolationCount((prev) => {
//             const newCount = prev + 1;
//             if (newCount >= maxViolations) {
//                 setTimeout(() => setShowSubmitModal({ open: true, isAuto: true }), 1500);
//             }
//             return newCount;
//         });
//     };

//     const selectOption = (qIndex, optIndex) => {
//         const question = questions[qIndex];
//         const newAnswers = [...answers];

//         if (question.question_type_id === 1) {
//             newAnswers[qIndex] = newAnswers[qIndex] === optIndex ? null : optIndex;
//         } else if (question.question_type_id === 2) {
//             const prev = Array.isArray(newAnswers[qIndex]) ? newAnswers[qIndex] : [];
//             newAnswers[qIndex] = prev.includes(optIndex)
//                 ? prev.filter((i) => i !== optIndex)
//                 : [...prev, optIndex];
//         } else {
//             newAnswers[qIndex] = optIndex;
//         }

//         setAnswers(newAnswers);

//         const isEmpty =
//             question.question_type_id === 1 ? newAnswers[qIndex] == null :
//                 question.question_type_id === 2 ? (!Array.isArray(newAnswers[qIndex]) || newAnswers[qIndex].length === 0) :
//                     !newAnswers[qIndex]?.trim();

//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = isEmpty ? "not-answered" : "answered";
//             return ns;
//         });
//     };

//     const clearResponse = (qIndex) => {
//         const newAnswers = [...answers];
//         newAnswers[qIndex] = null;
//         setAnswers(newAnswers);

//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = "not-answered";
//             return ns;
//         });
//     };

//     const markReview = (qIndex) => {
//         setStatus((prev) => {
//             const ns = [...prev];
//             ns[qIndex] = "marked";
//             return ns;
//         });
//     };

//     const nextQ = () => {
//         if (currentQ < questions.length - 1) setCurrentQ(currentQ + 1);
//     };

//     const prevQ = () => {
//         if (currentQ > 0) setCurrentQ(currentQ - 1);
//     };

//     const loadQuestion = (index) => setCurrentQ(index);

//     const handleSubmit = () => {
//         setShowSubmitModal({ open: true, isAuto: false });
//     };

//     const handleFinalSubmit = () => {
//         setSubmitted(true);
//         setShowSubmitModal({ open: false, isAuto: false });
//     };

//     const answeredCount = status.filter(s => s === "answered").length;
//     const markedCount = status.filter(s => s === "marked").length;
//     const notAnsweredCount = status.filter(s => s === "not-answered").length;
//     const unansweredMandatory = questions.filter((q, i) => q.is_mandatory && status[i] !== "answered").length;

//     if (submitted) {
//         return (
//             <ExamResults
//                 questions={questions}
//                 answers={answers}
//                 status={status}
//                 usedTime={usedTime}
//                 exam={exam}
//             />
//         );
//     }

//     if (!questions.length) {
//         return <div className="text-center mt-5">Loading mock exam...</div>;
//     }

//     const currentQuestion = questions[currentQ];

//     return (
//         <>
//             {tourStepIndex !== null && tourStepIndex >= 0 && (
//                 <GuidedTour
//                     steps={fullTourSteps}
//                     stepIndex={tourStepIndex}
//                     setStepIndex={setTourStepIndex}
//                     onFinish={() => setTourStepIndex(null)}
//                     allowNavigation={true}
//                 />
//             )}
//             <div className="exam-portal">
//                 <div className="dev-violation-tool" style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
//     <button
//         className="violation-btn"
//         onClick={simulateViolation}
//         style={{
//             background: "#e74c3c",
//             color: "white",
//             padding: "6px 12px",
//             border: "none",
//             borderRadius: 4
//         }}
//     >
//         Violation ({violationCount}/{maxViolations})
//     </button>
// </div>

//                 <div style={{ marginTop: 50 }}>
//                     <ExamHeader title={exam.Title} timeLeft={timeLeft} />
//                 </div>

//                 <div className="container">
//                     <div>
//                         <ExamQuestionCard
//                             question={currentQuestion}
//                             questionIndex={currentQ}
//                             selectedAnswer={answers[currentQ]}
//                             totalQuestions={questions.length}
//                             onAnswerSelect={selectOption}
//                             onPrevious={prevQ}
//                             onNext={nextQ}
//                             onMarkReview={markReview}
//                             onClearResponse={clearResponse}
//                         />
//                     </div>

//                     <div className="QuestionSubmit">
//                         <QuestionNavigator
//                             questions={questions}
//                             status={status}
//                             currentQuestion={currentQ}
//                             onQuestionSelect={loadQuestion}
//                             onSubmit={handleSubmit}
//                         />
//                         <ProgressOverview status={status} />
//                     </div>
//                 </div>

//                 <SubmitExamDialogDemo
//                     open={showSubmitModal.open}
//                     isAuto={showSubmitModal.isAuto}
//                     onClose={() => setShowSubmitModal({ open: false, isAuto: false })}
//                     onSubmit={handleFinalSubmit}
//                     answeredCount={answeredCount}
//                     notAnsweredCount={notAnsweredCount}
//                     markedCount={markedCount}
//                     examId="mock-001"
//                     examEmployeeId="EMP-TEST-123"
//                     unansweredMandatoryCount={unansweredMandatory}
//                 />
//             </div>
//         </>
//     );
// }

// src/pages/ExamPortalMock.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ExamHeader from "../../ExamPage/ExamHeader";
import ExamQuestionCard from "../../ExamPage/ExamQuestionCard";
import QuestionNavigator from "../../ExamPage/QuestionNavigator";
import ProgressOverview from "../../ExamPage/ProgressOverview";
import SubmitExamDialogDemo from "./SubmitExamDialogDemo";
import ExamResults from "../../ExamPage/ExamResults";
import "../../ExamPage/Exam.css";
import GuidedTour from "../GuidedTour";
import { fullTourSteps } from "../tourSteps";

export default function ExamPortalMock() {
    const [currentQ, setCurrentQ] = useState(0);
    const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes
    const [usedTime, setUsedTime] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [showSubmitModal, setShowSubmitModal] = useState({ open: false, isAuto: false });

    // Simple violation simulation (for testing)
    const [violationCount, setViolationCount] = useState(0);
    const maxViolations = 3;

    // Tour handling
    const location = useLocation();
    const navigate = useNavigate();

    const [tourStepIndex, setTourStepIndex] = useState(() => {
        if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {
            return location.state.stepIndex;
        }
        return null;
    });

    useEffect(() => {
        if (location.state?.resumeTour) {
            navigate(".", { replace: true, state: {} });
        }
    }, [location.state, navigate]);

    // Mock exam data
    const exam = {
        Title: "Mock Online Test - Python Basics",
        "Duration(min)": 30,
        PassPercent: 60,
        ReviewWithAnswers: true,
    };

    // Hardcoded questions
    const questions = [
        {
            q: "What is the correct way to create a function in Python?",
            options: [
                { key: "A", text: "function myFunc():" },
                { key: "B", text: "def myFunc():" },
                { key: "C", text: "create myFunc():" },
                { key: "D", text: "func myFunc():" },
            ],
            questionId: "q1",
            question_type_id: 1,
            marks: 1,
            is_mandatory: true,
        },
        {
            q: "Which of these are mutable in Python? (select all)",
            options: [
                { key: "A", text: "list" },
                { key: "B", text: "tuple" },
                { key: "C", text: "set" },
                { key: "D", text: "string" },
            ],
            questionId: "q2",
            question_type_id: 2,
            marks: 2,
            is_mandatory: true,
        },
        {
            q: "What does PEP stand for?",
            options: [],
            questionId: "q3",
            question_type_id: 3,
            marks: 1,
            is_mandatory: false,
        },
    ];

    const [answers, setAnswers] = useState(Array(questions.length).fill(null));
    const [status, setStatus] = useState(Array(questions.length).fill("not-visited"));

    // Timer
    useEffect(() => {
        if (submitted || timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    setShowSubmitModal({ open: true, isAuto: true });
                    return 0;
                }
                return prev - 1;
            });
            setUsedTime((prev) => prev + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [submitted]);

    // Violation simulation
    const simulateViolation = () => {
        if (violationCount >= maxViolations) return;
        setViolationCount((prev) => {
            const newCount = prev + 1;
            if (newCount >= maxViolations) {
                setTimeout(() => setShowSubmitModal({ open: true, isAuto: true }), 1500);
            }
            return newCount;
        });
    };

    const selectOption = (qIndex, optIndex) => {
        const question = questions[qIndex];
        const newAnswers = [...answers];

        if (question.question_type_id === 1) {
            newAnswers[qIndex] = newAnswers[qIndex] === optIndex ? null : optIndex;
        } else if (question.question_type_id === 2) {
            const prev = Array.isArray(newAnswers[qIndex]) ? newAnswers[qIndex] : [];
            newAnswers[qIndex] = prev.includes(optIndex)
                ? prev.filter((i) => i !== optIndex)
                : [...prev, optIndex];
        } else {
            newAnswers[qIndex] = optIndex;
        }

        setAnswers(newAnswers);

        const isEmpty =
            question.question_type_id === 1 ? newAnswers[qIndex] == null :
                question.question_type_id === 2 ? (!Array.isArray(newAnswers[qIndex]) || newAnswers[qIndex].length === 0) :
                    !newAnswers[qIndex]?.trim();

        setStatus((prev) => {
            const ns = [...prev];
            ns[qIndex] = isEmpty ? "not-answered" : "answered";
            return ns;
        });
    };

    const clearResponse = (qIndex) => {
        const newAnswers = [...answers];
        newAnswers[qIndex] = null;
        setAnswers(newAnswers);

        setStatus((prev) => {
            const ns = [...prev];
            ns[qIndex] = "not-answered";
            return ns;
        });
    };

    const markReview = (qIndex) => {
        setStatus((prev) => {
            const ns = [...prev];
            ns[qIndex] = "marked";
            return ns;
        });
    };

    // Navigation functions
    const nextQ = () => {
        if (currentQ < questions.length - 1) {
            setCurrentQ(currentQ + 1);
        }
    };

    const prevQ = () => {
        if (currentQ > 0) {
            setCurrentQ(currentQ - 1);
        }
    };

    const loadQuestion = (index) => setCurrentQ(index);

    const handleSubmit = () => {
        setShowSubmitModal({ open: true, isAuto: false });
    };

    const handleFinalSubmit = () => {
        setSubmitted(true);
        setShowSubmitModal({ open: false, isAuto: false });
    };

    const answeredCount = status.filter(s => s === "answered").length;
    const markedCount = status.filter(s => s === "marked").length;
    const notAnsweredCount = status.filter(s => s === "not-answered").length;
    const unansweredMandatory = questions.filter((q, i) => q.is_mandatory && status[i] !== "answered").length;

    if (submitted) {
        return (
            <ExamResults
                questions={questions}
                answers={answers}
                status={status}
                usedTime={usedTime}
                exam={exam}
            />
        );
    }

    if (!questions.length) {
        return <div className="text-center mt-5">Loading mock exam...</div>;
    }

    const currentQuestion = questions[currentQ];

    return (
        <>
            {tourStepIndex !== null && tourStepIndex >= 0 && (
                <GuidedTour
                    steps={fullTourSteps}
                    stepIndex={tourStepIndex}
                    setStepIndex={setTourStepIndex}
                    onFinish={() => setTourStepIndex(null)}
                    allowNavigation={true}
                />
            )}

            <div className="exam-portal">
                {/* Dev tool for violation simulation */}
                <div className="dev-violation-tool" style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
                    <button
                        className="violation-btn"
                        onClick={simulateViolation}
                        style={{
                            background: "#e74c3c",
                            color: "white",
                            padding: "6px 12px",
                            border: "none",
                            borderRadius: 4
                        }}
                    >
                        Violation ({violationCount}/{maxViolations})
                    </button>
                </div>

                <div style={{ marginTop: 50 }}>
                    <ExamHeader title={exam.Title} timeLeft={timeLeft} />
                </div>

                <div className="container">
                    <div>
                        <ExamQuestionCard
                            question={currentQuestion}
                            questionIndex={currentQ}
                            selectedAnswer={answers[currentQ]}
                            totalQuestions={questions.length}
                            onAnswerSelect={(optIndex) => selectOption(currentQ, optIndex)}
                            onPrevious={prevQ}           // ← Connected here
                            onNext={nextQ}               // ← Connected here
                            onMarkReview={() => markReview(currentQ)}
                            onClearResponse={() => clearResponse(currentQ)}
                        />
                    </div>

                    <div className="QuestionSubmit">
                        <QuestionNavigator
                            questions={questions}
                            status={status}
                            currentQuestion={currentQ}
                            onQuestionSelect={loadQuestion}
                            onSubmit={handleSubmit}
                        />
                        <ProgressOverview status={status} />
                    </div>
                </div>

                <SubmitExamDialogDemo
                    open={showSubmitModal.open}
                    isAuto={showSubmitModal.isAuto}
                    onClose={() => setShowSubmitModal({ open: false, isAuto: false })}
                    onSubmit={handleFinalSubmit}
                    answeredCount={answeredCount}
                    notAnsweredCount={notAnsweredCount}
                    markedCount={markedCount}
                    examId="mock-001"
                    examEmployeeId="EMP-TEST-123"
                    unansweredMandatoryCount={unansweredMandatory}
                />
            </div>
        </>
    );
}